/* eslint-disable */
import axios from "axios"


export default {
    methods: {
        /**
         * Método que serve para popular a tabela
         * @param  {Object} params - Objeto padrão usado na querystring
         * @return {Promise<
         * {
         *    "conteudo": [
         *      {
         *        "codigo": "string",
         *        "cpfCnpj": "string",
         *        "id": 0,
         *        "nome": "string",
         *        "rede": {
         *          "chave": "PROCESSANDO",
         *          "descricao": "string"
         *        },
         *        "status": {
         *          "chave": "PROCESSANDO",
         *          "descricao": "string"
         *        },
         *        "tipo": {
         *          "chave": "PROCESSANDO",
         *          "descricao": "string"
         *        },
         *        "unimedOrigem": "string"
         *      }
         *    ],
         *    "numeroPagina": 0,
         *    "tamanhoPagina": 0,
         *    "totalElementos": 0,
         *    "totalPaginas": 0
         *  }
         * >}
         */
        getTabelaRecursosProprios(params) {
            return axios.get(this.CriarUrl({
                resource: "/recursos_proprios/prestadores",
                params
            }));
        },
        /**
         * Retorna todas as redes do prestador
         * @return {
         * [
         *    {
         *      "chave": "PROCESSANDO",
         *      "descricao": "string"
         *    }
         *  ]
         * }
         */
        getRedes() {
            return axios.get(this.CriarUrl({
                resource: `prestadores/redes`
            }))
        },
        /**
         * Retorna todas os status do prestador
         * @return {
         * [
         *    {
         *      "chave": "PROCESSANDO",
         *      "descricao": "string"
         *    }
         *  ]
         * }
         */
        getStatus() {
            return axios.get(this.CriarUrl({
                resource: `prestadores/status`
            }))
        },
        /**
         * Retorna todos os tipos do prestador
         * @return {
         * [
         *    {
         *      "chave": "PROCESSANDO",
         *      "descricao": "string"
         *    }
         *  ]
         * }
         */
        getTipos() {
            return axios.get(this.CriarUrl({
                resource: `prestadores/tipos`
            }))
        }
    }
}